'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DriverIcon = function (_React$Component) {
    _inherits(DriverIcon, _React$Component);

    function DriverIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DriverIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DriverIcon.__proto__ || Object.getPrototypeOf(DriverIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 48' },
                _react2.default.createElement(
                    'g',
                    { id: 'DriverIcon', transform: 'translate(-570 -359)' },
                    _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: width, height: height, transform: 'translate(570 359)', fill: 'transparent' }),
                    _react2.default.createElement(
                        'g',
                        { id: 'Wayfinding_Disability_disability-sit-walking-aid', 'data-name': 'Wayfinding / Disability / disability-sit-walking-aid', transform: 'translate(51.004 -1747.615)' },
                        _react2.default.createElement(
                            'g',
                            { id: 'Group_145', 'data-name': 'Group 145', transform: 'translate(523.25 2108.4)' },
                            _react2.default.createElement(
                                'g',
                                { id: 'Regular_145', 'data-name': 'Regular 145' },
                                _react2.default.createElement('path', { id: 'Oval_135', 'data-name': 'Oval 135', d: 'M529.39,2119.469a5.539,5.539,0,1,0-5.765-5.535A5.653,5.653,0,0,0,529.39,2119.469Z', transform: 'translate(-522.801 -2108.4)', fill: 'none', stroke: primary, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' }),
                                _react2.default.createElement('path', { id: 'Shape_678', 'data-name': 'Shape 678', d: 'M523.25,2127.12h13.178', transform: 'translate(-523.25 -2086.004)', fill: 'none', stroke: primary, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' }),
                                _react2.default.createElement('path', { id: 'Shape_679', 'data-name': 'Shape 679', d: 'M533.9,2128.251h6.207a6.489,6.489,0,0,1,6.506,5.317l1.149,6.831a3.181,3.181,0,0,1-2.728,3.626,3.281,3.281,0,0,1-3.778-2.618l-1.149-6.831h-6.2a6.544,6.544,0,0,1-6.394-4.795l-2.66-10.257a3.16,3.16,0,0,1,2.4-3.835,3.528,3.528,0,0,1,.788-.09h16.473a3.165,3.165,0,1,1,0,6.325H532.255Z', transform: 'translate(-521.449 -2099.786)', fill: 'none', stroke: primary, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': '2' }),
                                _react2.default.createElement('line', { id: 'Line_46', 'data-name': 'Line 46', x1: '6', y2: '16', transform: 'translate(31.246 9.715)', fill: 'none', stroke: primary, 'stroke-linecap': 'round', 'stroke-width': '2' })
                            )
                        )
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DriverIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                this.getIcon(size, size, this.props.primary)
            );
        }
    }]);

    return DriverIcon;
}(_react2.default.Component);

exports.default = DriverIcon;